import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../firebase';
import { parseContents } from '../utils';
import { ContentGroupType } from '../types/others';

export const getCategories = async (): Promise<string[]> => {
  try {
    const result = await getDocs(collection(db, 'categories'));
    const parsedResult = parseContents(result);

    return parsedResult?.reduce((res, item) => (item?.name ? res?.concat(item?.name) : res), [] as string[]).sort();
  } catch (error) {
    console.log('[APP SETTINGS] Error at getCategories:', error);
    return [];
  }
};

export const getPillars = async (): Promise<string[]> => {
  try {
    const result = await getDocs(collection(db, 'pillars'));
    const parsedResult = parseContents(result);

    return parsedResult?.reduce((res, item) => (item?.name ? res?.concat(item?.name) : res), [] as string[]).sort();
  } catch (error) {
    console.log('[APP SETTINGS] Error at getPillars:', error);
    return [];
  }
};

export const getPillarExpertises = async (): Promise<string[]> => {
  try {
    const result = await getDocs(collection(db, 'pillarExpertise'));
    const parsedResult = parseContents(result);

    return parsedResult?.reduce((res, item) => (item?.name ? res?.concat(item?.name) : res), [] as string[]).sort();
  } catch (error) {
    console.log('[APP SETTINGS] Error at getPillarExpertises:', error);
    return [];
  }
};

export const getContentGroupIds = async (type?: ContentGroupType): Promise<{ title: string; id: string }[]> => {
  try {
    let q;
    if (type) {
      q = query(collection(db, 'contentGroups'), where('type', '==', type));
    } else {
      q = collection(db, 'contentGroups');
    }
    const result = await getDocs(q);
    const parsedResult = parseContents(result);

    return parsedResult
      ?.reduce(
        (res, item) => (item?.id && item?.title ? res?.concat({ title: item?.title, id: item?.id }) : res),
        [] as { title: string; id: string }[],
      )
      .sort();
  } catch (error) {
    console.log('[APP SETTINGS] Error at getPurchaseIds:', error);
    return [];
  }
};
